import { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog as BaseDialog,
  DialogActions,
  DialogContent,
  IconButton,
  SxProps
} from '@mui/material';

const Dialog = ({
  open,
  handleClose,
  text,
  actionButtonText = 'OK',
  handleAction,
  hasCrossCloseButton,
  hasCancelButton,
  cancelButtonText = 'Cancel',
  sx
}: {
  handleClose: (arg?: any) => void;
  open: boolean;
  text: ReactNode;
  actionButtonText?: ReactNode;
  handleAction: (arg?: any) => void;
  hasCrossCloseButton?: boolean;
  hasCancelButton?: boolean;
  cancelButtonText?: string;
  sx?: SxProps;
}) => {
  return (
    <BaseDialog
      open={open}
      sx={{ backgroundColor: '#2634c866', ...sx }}
      onClose={handleClose}
    >
      {hasCrossCloseButton && (
        <IconButton
          aria-label='close'
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'info.dark'
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent sx={{ backgroundColor: 'background.default', minWidth: 500, pr: 5 }}>
        <Box sx={{ color: 'text.primary' }}>{text}</Box>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: 'background.default', p: 3, pt: 1 }}>
        {hasCancelButton && (
          <Button
            sx={{ mr: 1, minWidth: 100 }}
            onClick={handleClose}
          >
            {cancelButtonText}
          </Button>
        )}
        <Button
          sx={{ minWidth: 100 }}
          variant='contained'
          onClick={handleAction}
        >
          {actionButtonText}
        </Button>
      </DialogActions>
    </BaseDialog>
  );
};

export default Dialog;
